function inline_edit_init() {
  $('.inline-edit').each(function () {
    inline_edit(this);
  });
}

function inline_edit(elem) {
  let item = $(elem).data('item');
  let field = $(elem).data('field');
  let item_id = $(elem).data(item);
  let data_type = $(elem).data('type');
  let val_elem = '.inline-val';
  let input_elem = '.inline-input';

  $(elem).on('click', val_elem, function () {
    $(this).parent().hide();
    let parent = $(this).closest('.inline-edit');
    let input = $(parent).find(input_elem);
    if (data_type == 'text' || data_type == 'date') {
      $(input).attr('type', data_type).focus();
    } else if (data_type == 'textarea') {
      $(input).show().focus();
      autosize($(input));
    } else if (data_type == 'select') {
      $(input).closest('.field').show();
      $(input).focus();
    }
  });

  if (data_type == 'select') {
    $(elem).on('change', input_elem, function () {
      inline_edit_finish(this, item, field, item_id);
    }).on('focusout', input_elem, function () {
      inline_edit_done(this);
    });
  } else if (data_type == 'date') {
    // TODO date field fires focusout if Enter pressed
    // No side effects but it would be nice to fix
    $(elem).on('focusout', input_elem, function () {
      inline_edit_finish(this, item, field, item_id);
    }).on('keyup', input_elem, function (event) {
      if (event.key === 'Enter') {
        inline_edit_finish(this, item, field, item_id);
      }
    });
  } else {
    $(elem).on('focusout', input_elem, function () {
      if ($(input_elem).hasClass('esc-triggered')) {
        $(input_elem).removeClass('esc-triggered');
      } else {
        inline_edit_finish(this, item, field, item_id);
      }
    }).on('keyup', input_elem, function (event) {
      if (event.key === 'Enter') {
        if (data_type != 'textarea') {
          inline_edit_finish(this, item, field, item_id);
        }
      } else if (event.key === 'Escape') {
        $(input_elem).addClass('esc-triggered');
        inline_edit_done(this);
      }
    });
  }
}

function inline_edit_finish(input_elem, item, field, id) {
  inline_edit_request({
    item: item,
    field: field,
    id: id,
    value: $(input_elem).val(),
  }, input_elem);
}

function inline_edit_done(input_elem, value = null) {
  let parent = $(input_elem).closest('.inline-edit');
  let data_type = $(parent).data('type');
  if (data_type == 'text' || data_type == 'date') {
    $(input_elem).attr('type', 'hidden');
  } else if (data_type == 'textarea') {
    $(input_elem).hide();
  } else if (data_type == 'select') {
    $(input_elem).closest('.field').hide();
  } else {
    show_error('Unsupported data type: "' + data_type + '"');
  }
  if (value) {
    let val_elem = $(parent).children('.inline-edit-wrap').children('.inline-val');
    if (data_type == 'text') {
      $(val_elem).text(value);
      $(input_elem).attr('placeholder', value);
    } else if (data_type == 'date') {
      let text = (value) ? value : 'Not set';
      $(val_elem).text(text);
      $(input_elem).val(value);
    } else if (data_type == 'textarea') {
      let html = (value != '<p></p>') ? value : $(input_elem).attr('placeholder');
      $(val_elem).html(html);
      $(input_elem).html(value);
    } else if (data_type == 'select') {
      $(val_elem).text(value);
    }
  }
  $(parent).children('.inline-edit-wrap').show();
}

function inline_edit_request(data, input_elem) {
  $.ajax({
    method: 'POST',
    url: inline_edit_api,
    dataType: 'json',
    data: data
  }).done(function (ret) {
    if (ret.Executed) {
      inline_edit_done(input_elem, ret.Value);
      if (ret.Message) {
        show_notification(ret.Message, ret.Level);
        if (typeof issue_notify_button_enable === 'function') {
          issue_notify_button_enable(); // Show notify button here as change happened
        }
      }
      if (ret.Callback) {
        if (typeof window[ret.Callback] === 'function') {
          window[ret.Callback]();
        } else {
          show_error("Callback function is missing");
        }
      }
    } else {
      show_error(ret.Message);
    }
  }).fail(function () {
    show_error("Unexpected error occurred!");
  });
}
